import RegisterForm from "components/Forms/custom/RegisterForm";
import InfoLayout from "components/InfoLayout/InfoLayout";

const Register = () => {
  return <InfoLayout component={<RegisterForm />} />;
};

export default Register;
